// // import React, { useState } from "react";
// // import { useDispatch } from "react-redux";
// // import { useNavigate } from "react-router-dom";
// // import { loginUser } from "../redux/auth/authActions";
// // import Loader from "../components/Loader"; // Import your reusable Loader
// // import "../assets/css/setPassword.css"; // Import your CSS
// // import { showApiErrorToast } from "../utils/toastErrorHandler";
// // import { toast } from "react-toastify";

// // const Login = () => {
// //   const navigate = useNavigate();
// //   const dispatch = useDispatch();

// //   // Form State
// //   const [email, setEmail] = useState("");
// //   const [password, setPassword] = useState("");
// //   const [showPassword, setShowPassword] = useState(false);

// //   // Loading State
// //   const [isLoading, setIsLoading] = useState(false);

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setIsLoading(true); // Start Loader

// //     try {
// //       // 1. Dispatch Login Action
// //       const resultAction = await dispatch(
// //         loginUser({
// //           email: email,
// //           password: password,
// //         }),
// //       );

// //       // 2. Check if the action was fulfilled (Success)
// //       if (loginUser.fulfilled.match(resultAction)) {
// //         const responseData = resultAction.payload;

// //         if (responseData.success) {
// //           // --- SUCCESS ---
// //           // Save token with key "token" to match App.js logic
// //           localStorage.setItem("token", responseData.data.token);

// //           // Optional: Save user details
// //           localStorage.setItem("user", JSON.stringify(responseData.data));
// //           localStorage.removeItem("dashboard_animation_played");
// //           // Redirect to Dashboard & Reload to update App state
// //           toast.success(responseData.message, {
// //             autoClose: 3000, // 3000ms = 3 seconds
// //             hideProgressBar: false,
// //             closeOnClick: true,
// //             pauseOnHover: true,
// //             draggable: true,
// //           });
// //           setIsLoading(false);
// //           setTimeout(() => {
// //             window.location.href = "/dashboard";
// //           }, 1000);

// //           // navigate("/dashboard");
// //         } else {
// //           // --- LOGIC FAILURE (e.g., Wrong Password) ---
// //           showApiErrorToast(responseData.message);
// //           setIsLoading(false); // Stop Loader
// //         }
// //       } else {
// //         // --- NETWORK/API ERROR ---
// //         const errorMessage =
// //           resultAction.payload || "Login failed. Please try again.";

// //         if (
// //           errorMessage ==
// //           "Failed to connect to 103.131.196.130:1433 - Could not connect (sequence)"
// //         ) {
// //           showApiErrorToast("Your database connection loss");
// //         } else {
// //           showApiErrorToast(errorMessage);
// //         }
// //         setIsLoading(false); // Stop Loader
// //       }
// //     } catch (error) {
// //       showApiErrorToast(error.message);
// //       setIsLoading(false); // Stop Loader
// //     }
// //   };

// //   return (
// //     <div className="password-page-wrapper">
// //       {/* 1. Full Screen Loader Component */}
// //       <Loader isLoading={isLoading} />

// //       {/* 2. Purple Header Bar */}
// //       <div className="purple-header-bar">
// //         <h2 className="header-title">Welcome Back</h2>
// //       </div>

// //       {/* 3. Wave SVG */}
// //       <div className="wave-container">
// //         <svg
// //           viewBox="0 0 1440 320"
// //           xmlns="http://www.w3.org/2000/svg"
// //           preserveAspectRatio="none"
// //         >
// //           <path
// //             fill="#5b5fef"
// //             fillOpacity="1"
// //             d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,122.7C960,117,1056,171,1152,197.3C1248,224,1344,224,1392,224L1440,224L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
// //           ></path>
// //         </svg>
// //       </div>

// //       {/* 4. Login Form */}
// //       <div className="white-content-area">
// //         <div className="content-container">
// //           <h3 className="fw-bold mb-3 text-center text-dark">Log In</h3>
// //           <p className="text-muted text-center mb-4 small-text">
// //             Please sign in to continue using our app
// //           </p>

// //           <form onSubmit={handleSubmit}>
// //             {/* Email Field */}
// //             <div className="form-group mb-3">
// //               <label className="form-label">Email Address</label>
// //               <div className="custom-input-group">
// //                 <input
// //                   type="email"
// //                   className="custom-input"
// //                   placeholder="name@example.com"
// //                   value={email}
// //                   onChange={(e) => setEmail(e.target.value)}
// //                   required
// //                 />
// //                 <i
// //                   className="bi bi-envelope password-toggle-icon"
// //                   style={{ pointerEvents: "none" }}
// //                 ></i>
// //               </div>
// //             </div>

// //             {/* Password Field */}
// //             <div className="form-group mb-4">
// //               <label className="form-label">Password</label>
// //               <div className="custom-input-group">
// //                 <input
// //                   type={showPassword ? "text" : "password"}
// //                   className="custom-input"
// //                   placeholder="••••••••••••"
// //                   value={password}
// //                   onChange={(e) => setPassword(e.target.value)}
// //                   required
// //                 />
// //                 <i
// //                   className={bi ${showPassword ? "bi-eye-slash" : "bi-eye"} password-toggle-icon}
// //                   onClick={() => setShowPassword(!showPassword)}
// //                   style={{ cursor: "pointer" }}
// //                 ></i>
// //               </div>
// //             </div>

// //             {/* Submit Button */}
// //             <button
// //               type="submit"
// //               className="btn-primary-custom-model w-100"
// //               disabled={isLoading} // Disable while loading
// //               style={{
// //                 opacity: isLoading ? 0.7 : 1,
// //                 cursor: isLoading ? "not-allowed" : "pointer",
// //               }}
// //             >
// //               Log In
// //             </button>
// //           </form>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Login;




// import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { loginUser } from "../redux/auth/authActions";
// import Loader from "../components/Loader"; // Import your reusable Loader
// import "../assets/css/login.css"; // Import your CSS
// import left from "../assets/images/left-background.png"
// import skyeye from "../assets/images/sky-rp-logo.png"
// import google from "../assets/images/google.png"
// import facebook from "../assets/images/facebook.png"
// import github from "../assets/images/github.png"
// import { showApiErrorToast } from "../utils/toastErrorHandler";
// import { toast } from "react-toastify";
// import { GoogleLogin } from "@react-oauth/google";
// import { googleLogin, verifyOtp, resendOtp } from "../redux/auth/authActions";

// // const Login = () => {
// //   const navigate = useNavigate();
// //   const dispatch = useDispatch();

// //   // Form State
// //   const [email, setEmail] = useState("");
// //   const [password, setPassword] = useState("");
// //   const [showPassword, setShowPassword] = useState(false);
// //   const [errors, setErrors] = useState({});

// //   //OTP State

// //   const [showOtpModal, setShowOtpModal] = useState(false);
// //   const [otp, setOtp] = useState("");
// //   const [googleEmail, setGoogleEmail] = useState("");
// //   const [timeLeft, setTimeLeft] = useState(60); // 60 seconds
// //   const [otpExpired, setOtpExpired] = useState(false);
// //   const [timerKey, setTimerKey] = useState(0);

// //   // Loading State
// //   const [isLoading, setIsLoading] = useState(false);

// //   // Validation State
// //   const validateForm = () => {
// //     let newErrors = {};
// //     const emailRegex = /^[a-z][a-z0-9._]*@(gmail|yahoo)\.(com)$/;
// //     const passwordRegex = /^(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

// //     if (!email.trim()) {
// //       newErrors.email = "Email is required";
// //     } else if (!emailRegex.test(email)) {
// //       newErrors.email = "Enter a valid email address";
// //     }
// //     if (!password.trim()) {
// //       newErrors.password = "Password is requied";
// //     } else if (!passwordRegex.test(password)) {
// //       newErrors.password = "Enter valid password Eg: abc@123"
// //     }
// //     setErrors(newErrors);
// //     return Object.keys(newErrors).length === 0;
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     if (!validateForm()) return;
// //     setIsLoading(true); // Start Loader

// //     try {
// //       // 1. Dispatch Login Action
// //       const resultAction = await dispatch(
// //         loginUser({
// //           email,
// //           password,
// //         }),
// //       );

// //       // 2. Check if the action was fulfilled (Success)
// //       if (loginUser.fulfilled.match(resultAction)) {
// //         const responseData = resultAction.payload;

// //         if (responseData.success) {
// //           // --- SUCCESS ---
// //           // Save token with key "token" to match App.js logic
// //           localStorage.setItem("token", responseData.data.token);


// //           // Optional: Save user details
// //           localStorage.setItem("user", JSON.stringify(responseData.data));
// //           localStorage.removeItem("dashboard_animation_played");
// //           // Redirect to Dashboard & Reload to update App state
// //           toast.success(responseData.message, {
// //             autoClose: 3000, // 3000ms = 3 seconds
// //             hideProgressBar: false,
// //             closeOnClick: true,
// //             pauseOnHover: true,
// //             draggable: true,
// //           });
// //           setIsLoading(false);
// //           setTimeout(() => {
// //             window.location.href = "/dashboard";
// //           }, 1000);

// //           // navigate("/dashboard");
// //         } else {
// //           // --- LOGIC FAILURE (e.g., Wrong Password) ---
// //           showApiErrorToast(responseData.message);
// //           setIsLoading(false); // Stop Loader
// //         }
// //       } else {
// //         // --- NETWORK/API ERROR ---
// //         const errorMessage =
// //           resultAction.payload || "Login failed. Please try again.";
// //         if (
// //           errorMessage ==
// //           "Failed to connect to 103.131.196.130:1433 - Could not connect (sequence)"
// //         ) {
// //           showApiErrorToast("Your database connection loss");
// //         } else {
// //           showApiErrorToast(errorMessage);
// //         }
// //         setIsLoading(false); // Stop Loader
// //       }
// //     } catch (error) {
// //       showApiErrorToast(error.message);
// //       setIsLoading(false); // Stop Loader
// //     }
// //   };


// //   const handleGoogleSuccess = async (credentialResponse) => {
// //     console.log("Google Response:", credentialResponse);
// //     console.log("ID Token:", credentialResponse.credential);
// //     setIsLoading(true);
// //     try {
// //       const idToken = credentialResponse.credential;
// //       const result = await dispatch(
// //         googleLogin(credentialResponse.credential)
// //       );

// //       if (googleLogin.fulfilled.match(result)) {
// //         toast.success(result.payload.message);
// //         localStorage.setItem(
// //           "googleEmail",
// //           result.payload.data.email
// //         );
// //         // navigate("/verify-otp");
// //         setGoogleEmail(result.payload.data.email);
// //         setShowOtpModal(true);
// //         // toast.success("OTP sent to your email.");
// //       }
// //       else {
// //         showApiErrorToast(result.payload || "Google Login Failed");
// //       }
// //     } catch (err) {
// //       showApiErrorToast(err.message);
// //     }
// //     setIsLoading(false);
// //   };
// //   const handleGoogleError = () => {
// //     showApiErrorToast("Google Login Failed");
// //   };
// //   const handleVerifyOtp = async () => {

// //     const result = await dispatch(
// //       verifyOtp({
// //         email: googleEmail,
// //         otp
// //       })
// //     );
// //     if (verifyOtp.fulfilled.match(result)) {
// //       localStorage.setItem(
// //         "token",
// //         result.payload.data.token
// //       );
// //       localStorage.setItem(
// //         "user",
// //         JSON.stringify(result.payload.data)
// //       );
// //       toast.success("OTP Verified");
// //       setShowOtpModal(false);
// //       window.location.href = "/dashboard";
// //     }
// //     else {
// //       toast.error(result.payload?.message || "Invalid OTP");
// //     }
// //   };
// //   const handleResendOtp = async () => {
// //     const result = await dispatch(
// //       resendOtp(googleEmail)
// //     );
// //     if (resendOtp.fulfilled.match(result)) {
// //       toast.success(result.payload.message);
// //       setOtp("");
// //     setOtpExpired(false);
// //     // Restart timer
// //     setTimerKey(prev => prev + 1);
// //     } else {
// //       toast.error(result.payload);
// //     }
// //   };
// //   useEffect(() => {
// //     if (!showOtpModal) return;
// //     setOtpExpired(false);
// //     setTimeLeft(60);
// //     const timer = setInterval(() => {
// //       setTimeLeft((prev) => {
// //         if (prev <= 1) {
// //           clearInterval(timer);
// //           setOtpExpired(true);
// //           return 0;
// //         }
// //         return prev - 1;
// //       });
// //     }, 1000);
// //     return () => clearInterval(timer);
// //   }, [showOtpModal, timerKey]);
// //   return (
// //     <div className="login-page">
// //       {/* 1. Full Screen Loader Component */}
// //       <Loader isLoading={isLoading} />

// //       {/* 2. Login Card */}
// //       <div className="login-card">

// //         {/* 3. Left cointainer*/}
// //         <div className="login-left"
// //           style={{
// //             backgroundImage: `url(${left})`,
// //           }}>
// //           <div className="login-overlay">
// //             <div className="login-left-content">
// //               <h2>Work Smarter. <br />Track Better.</h2>
// //               <p>Experience a faster, smarter way to manage attendance
// //                 with real-time monitoring and effortless workforce visibility.
// //               </p>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Right Cointainer */}

// //         <div className="login-right-content">
// //           {/* <div className="login-logo-area">
// //             <img src={skyeye} alt="SkyEye" className="login-company-logo" />
// //             <span>SkyEye</span>
// //           </div> */}
// //           <h1>Welcome Back</h1>
// //           <form onSubmit={handleSubmit}>
// //             <div className="login-form-group">
// //               <label>Email Address <span>*</span></label>
// //               <div className="login-input-box">
// //                 <i className="bi bi-envelope"></i>
// //                 <input type="email"
// //                   placeholder="Enter your email"
// //                   value={email}
// //                   onChange={(e) => setEmail(e.target.value)} />
// //               </div>
// //               {errors.email && (
// //                 <small className="login-error-text"> {errors.email} </small>
// //               )}
// //             </div>
// //             <div className="login-form-group">
// //               <div className="login-password-label">
// //                 <label>Password <span>*</span></label>
// //                 <a href="/">Forgot Password?</a>
// //               </div>
// //               <div className="login-input-box">
// //                 <i className="bi bi-lock"></i>
// //                 <input type={showPassword ? "text" : "password"}
// //                   placeholder="Enter password"
// //                   value={password}
// //                   onChange={(e) => setPassword(e.target.value)} />
// //                 <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"} eye`}
// //                   onClick={() => setShowPassword(!showPassword)}></i>
// //               </div>
// //               {errors.password && (
// //                 <small className="login-error-text"> {errors.password} </small>
// //               )}
// //             </div>

// //             {/* Button */}
// //             <button type="submit" className="login-btn" disabled={isLoading}>
// //               {isLoading ? "Loging In..." : "Log In"}
// //             </button>
// //             <div className="social-login">
// //               <p>Or continue with</p>
// //               <div className="login-social-icons">
// //                 {/* <button type="button">
// //                   <img src={google} alt="Google" />
// //                 </button> */}
// //                 <GoogleLogin
// //                   onSuccess={handleGoogleSuccess}
// //                   onError={handleGoogleError}
// //                   useOneTap={false}
// //                   className="google-icon"
// //                 />
// //                 {/* <button type="button">
// //                   <img src={facebook} alt="Facebook" />
// //                 </button>
// //                 <button type="button">
// //                   <img src={github} alt="Github" />
// //                 </button> */}
// //               </div>
// //             </div>
// //           </form>
// //           {showOtpModal && (
// //             <div className="otp-overlay">
// //               <div className="otp-modal">

// //                 <button
// //                   className="otp-close"
// //                   onClick={() => setShowOtpModal(false)}
// //                 >
// //                   ✕
// //                 </button>

// //                 <div className="otp-header">

// //                   <div className="otp-header-content">

// //                     <div className="otp-logo">
// //                       <i className="bi bi-shield-check"></i>
// //                     </div>
// //                   </div>

// //                   <svg
// //                     className="otp-header-wave"
// //                     viewBox="0 0 500 160"
// //                     preserveAspectRatio="none"
// //                   >
// //                     <path
// //                       d="M0,70 C80,140 180,20 280,70 C360,110
// //                       430,60 500,90 L500,160 L0,160 Z"
// //                       fill="#ffffff"
// //                       opacity=".45"
// //                     />

// //                     <path
// //                       d="M0,90
// //                       C120,150
// //                       250,30
// //                       500,95
// //                       L500,160
// //                       L0,160
// //                       Z"
// //                       fill="#ffffff"
// //                     />
// //                   </svg>

// //                 </div>

// //                 <div className="otp-body">

// //                   <h2>Verify OTP</h2>

// //                   <p>
// //                     Enter the OTP sent to
// //                   </p>

// //                   <h5>{googleEmail}</h5>
// //                   <p className="otp-timer">
// //                     OTP expires in{" "}
// //                     <span>
// //                       00:{timeLeft.toString().padStart(2, "0")}
// //                     </span>
// //                   </p>
// //                   <input
// //                     type="text"
// //                     maxLength={6}
// //                     value={otp}
// //                     onChange={(e) => setOtp(e.target.value)}
// //                     placeholder="Enter OTP"
// //                   />

// //                   <small>
// //                     Didn't receive OTP?
// //                     <span className="resend" onClick={handleResendOtp}>
// //                       Resend OTP
// //                     </span>
// //                   </small>

// //                 </div>

// //                 <div className="otp-footer">

// //                   <button
// //                     className="cancel-btn"
// //                     onClick={() => setShowOtpModal(false)}
// //                   >
// //                     Cancel
// //                   </button>

// //                   <button
// //                     className={`verify-btn ${otpExpired ? "verify-btn-disabled" : ""}`}
// //                     onClick={handleVerifyOtp}
// //                     disabled={otpExpired}
// //                   >
// //                     Verify OTP
// //                   </button>

// //                 </div>

// //               </div>
// //             </div>
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Login;

// import React from "react";
// import "../assets/css/login.css";
// import google from "../assets/images/google.png"
// import avatar from "../assets/images/ava1.png";
// import team from "../assets/images/team1.png";
// import { easeOut, motion } from "framer-motion";
// import { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { loginUser } from "../redux/auth/authActions";
// import Loader from "../components/Loader"; // Import your reusable Loader
// import "../assets/css/setPassword.css"; // Import your CSS
// import { showApiErrorToast } from "../utils/toastErrorHandler";
// import { toast } from "react-toastify";

// const Login = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   // Form State
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);

//   // Loading State
//   const [isLoading, setIsLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true); // Start Loader

//     try {
//       // 1. Dispatch Login Action
//       const resultAction = await dispatch(
//         loginUser({
//           email: email,
//           password: password,
//         }),
//       );

//       // 2. Check if the action was fulfilled (Success)
//       if (loginUser.fulfilled.match(resultAction)) {
//         const responseData = resultAction.payload;

//         if (responseData.success) {
//           // --- SUCCESS ---
//           // Save token with key "token" to match App.js logic
//           localStorage.setItem("token", responseData.data.token);

//           // Optional: Save user details
//           localStorage.setItem("user", JSON.stringify(responseData.data));
//           localStorage.removeItem("dashboard_animation_played");
//           // Redirect to Dashboard & Reload to update App state
//           toast.success(responseData.message, {
//             autoClose: 3000, // 3000ms = 3 seconds
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           setIsLoading(false);
//           setTimeout(() => {
//             window.location.href = "/dashboard";
//           }, 1000);

//           // navigate("/dashboard");
//         } else {
//           // --- LOGIC FAILURE (e.g., Wrong Password) ---
//           showApiErrorToast(responseData.message);
//           setIsLoading(false); // Stop Loader
//         }
//       } else {
//         // --- NETWORK/API ERROR ---
//         const errorMessage =
//           resultAction.payload || "Login failed. Please try again.";

//         if (
//           errorMessage ==
//           "Failed to connect to 103.131.196.130:1433 - Could not connect (sequence)"
//         ) {
//           showApiErrorToast("Your database connection loss");
//         } else {
//           showApiErrorToast(errorMessage);
//         }
//         setIsLoading(false); // Stop Loader
//       }
//     } catch (error) {
//       showApiErrorToast(error.message);
//       setIsLoading(false); // Stop Loader
//     }
//   };


//   const handleGoogleSuccess = async (credentialResponse) => {
//     console.log("Google Response:", credentialResponse);
//     console.log("ID Token:", credentialResponse.credential);
//     setIsLoading(true);
//     try {
//       const idToken = credentialResponse.credential;
//       const result = await dispatch(
//         googleLogin(credentialResponse.credential)
//       );

//       if (googleLogin.fulfilled.match(result)) {
//         toast.success(result.payload.message);
//         localStorage.setItem(
//           "googleEmail",
//           result.payload.data.email
//         );
//         // navigate("/verify-otp");
//         setGoogleEmail(result.payload.data.email);
//         setShowOtpModal(true);
//         // toast.success("OTP sent to your email.");
//       }
//       else {
//         showApiErrorToast(result.payload || "Google Login Failed");
//       }
//     } catch (err) {
//       showApiErrorToast(err.message);
//     }
//     setIsLoading(false);
//   };
//   const handleGoogleError = () => {
//     showApiErrorToast("Google Login Failed");
//   };
//   const handleVerifyOtp = async () => {

//     const result = await dispatch(
//       verifyOtp({
//         email: googleEmail,
//         otp
//       })
//     );
//     if (verifyOtp.fulfilled.match(result)) {
//       localStorage.setItem(
//         "token",
//         result.payload.data.token
//       );
//       localStorage.setItem(
//         "user",
//         JSON.stringify(result.payload.data)
//       );
//       toast.success("OTP Verified");
//       setShowOtpModal(false);
//       window.location.href = "/dashboard";
//     }
//     else {
//       toast.error(result.payload?.message || "Invalid OTP");
//     }
//   };
//   const handleResendOtp = async () => {
//     const result = await dispatch(
//       resendOtp(googleEmail)
//     );
//     if (resendOtp.fulfilled.match(result)) {
//       toast.success(result.payload.message);
//       setOtp("");
//       setOtpExpired(false);
//       // Restart timer
//       setTimerKey(prev => prev + 1);
//     } else {
//       toast.error(result.payload);
//     }
//   };
//   useEffect(() => {
//     if (!showOtpModal) return;
//     setOtpExpired(false);
//     setTimeLeft(60);
//     const timer = setInterval(() => {
//       setTimeLeft((prev) => {
//         if (prev <= 1) {
//           clearInterval(timer);
//           setOtpExpired(true);
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 5000);
//     return () => clearInterval(timer);
//   }, [showOtpModal, timerKey]);
//   return (
//     <div className="password-page-wrapper">
//       {/* 1. Full Screen Loader Component */}
//       <Loader isLoading={isLoading} />
//       <div className="container-fluid h-100">
//         <div className="row h-100">
//           {/* LEFT */}
//           <div className="col-lg-6 left-panel">
//             <div className="content">
//               <h1>
//                 Welcome to
//                 <br />
//                 <span>SkyEye</span>
//               </h1>
//               <div className="line"></div>
//               <p>
//                 Skyeye is a smart platform that helps
//                 teams collaborate, manage projects,
//                 monitor tasks and achieve business
//                 goals efficiently.
//               </p>
//             </div>
//             {/* SVG */}
//             <svg
//               className="wave"
//               viewBox="0 0 500 900"
//               preserveAspectRatio="none"
//             >
//               <path
//                 d="
//                 M500 0

//       {/* 2. Purple Header Bar */}
//       // <div className="purple-header-bar">
//               <h2 className="header-title">Welcome Back</h2>
//           </div>

//           {/* 3. Wave SVG */}
//           <div className="wave-container">
//             <svg
//               viewBox="0 0 1440 320"
//               xmlns="http://www.w3.org/2000/svg"
//               preserveAspectRatio="none"
//             >
//               <path
//                 fill="#5b5fef"
//                 fillOpacity="1"
//                 d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,122.7C960,117,1056,171,1152,197.3C1248,224,1344,224,1392,224L1440,224L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
//               ></path>
//             </svg>
//           </div>

//           {/* 4. Login Form */}
//           <div className="white-content-area">
//             <div className="content-container">
//               <h3 className="fw-bold mb-3 text-center text-dark">Log In</h3>
//               <p className="text-muted text-center mb-4 small-text">
//                 Please sign in to continue using our app
//               </p>

//               <div className="col-lg-6 right-panel">
//                 <div className="login-wrapper">

//                   <motion.div
//                     className="avatar"
//                     // initial={{
//                     //   y: 1500,
//                     //   opacity: 0
//                     // }}
//                     // animate={{
//                     //   y: 0,
//                     //   opacity: 1
//                     // }}
//                     // transition={{
//                     //   // type: "spring",
//                     //   duration: 1,
//                     //   ease: "easeOut"
//                     //   // stiffness: 90,
//                     //   // damping: 12,
//                     // }}
//                     initial={{
//                       x: -250,
//                       opacity: 0
//                     }}
//                     animate={{
//                       x: 0,
//                       opacity: 1
//                     }}
//                     transition={{
//                       duration: 0.8,
//                       ease: "easeOut"

//                     }}
//                     onAnimationComplete={() => setShowForm(true)}
//                   >
//                     <img src={avatar} alt="" />
//                   </motion.div>
//                   <motion.div
//                     className="login-card"
//                     // initial={{
//                     //   opacity: 0,
//                     //   scale: 0.8,
//                     //   y: 40,
//                     // }}
//                     // animate={
//                     //   showForm
//                     //     ? {
//                     //       opacity: 1,
//                     //       scale: 1,
//                     //       y: 0,
//                     //     }
//                     //     : {
//                     //       opacity: 0,
//                     //       scale: 0.8,
//                     //       y: 40,
//                     //     }
//                     // }

//                     // transition={{
//                     //   // type: "spring",
//                     //   duration: 0.4,
//                     //   ease: "easeOut",
//                     //   // stiffness: 10,
//                     //   // damping: 12,
//                     // }}
//                     initial={{
//                       x: 250,
//                       opacity: 0
//                     }}
//                     animate={{
//                       x: 0,
//                       opacity: 1
//                     }}
//                     transition={{
//                       duration: 0.8,
//                       ease: "easeOut"

//                     }}
//                     onAnimationComplete={() => setShowForm(true)}
//                   >
//                     <form onSubmit={handleSubmit} className="login-form">
//                       <h2>Login</h2>
//                       <p>
//                         Welcome Back! Please login
//                         to continue.
//                       </p>
//                       <div className="mb-3">
//                         <label>Email <span>*</span></label>
//                         <input
//                           className="form-control"
//                           type="email"
//                           placeholder="Enter email"
//                           value={email}
//                           onChange={(e) => setEmail(e.target.value)}
//                         />
//                         {
//                           errors.email &&
//                           (
//                             <small className="login-error-text">
//                               {errors.email}
//                             </small>
//                           )
//                         }
//                       </div>
//                       <div className="password mb-3">
//                         <label>Password <span>*</span></label>
//                         <div className="password-box">
//                           <input
//                             className="form-control"
//                             type={showPassword ? "text" : "password"}
//                             placeholder="Enter password"
//                             value={password}
//                             onChange={(e) => setPassword(e.target.value)}
//                           />
//                           <i
//                             className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"} eye`}
//                             onClick={() => setShowPassword(!showPassword)}
//                           ></i>
//                         </div>
//                         {
//                           errors.password &&
//                           (
//                             <small className="login-error-text">
//                               {errors.password}
//                             </small>
//                           )
//                         }

//                       </div>
//                       {/* <div className="forgot-password">
//                     <a href="/">Forgot Password?</a>
//                   </div> */}
//                       <button
//                         type="submit"
//                         className="btn login-btn mt-4"
//                         disabled={isLoading}
//                       >

//                         {
//                           isLoading
//                             ?
//                             "Logging In..."
//                             :
//                             "Login"
//                         }

//                       </button>
//                       <div className="social-login">
//                         <p>Or continue with</p>
//                         <div className="login-social-icons">

//                           <GoogleLogin
//                             onSuccess={handleGoogleSuccess}
//                             onError={handleGoogleError}
//                             useOneTap={false}
//                             className="google-icon" />

//                         </div>
//                       </div>
//                     </form>
//                   </motion.div>
//                 </div>
//               </div>
//               {showOtpModal && (
//                 <div className="otp-overlay">
//                   <div className="otp-modal">

//                     <button
//                       className="otp-close"
//                       onClick={() => setShowOtpModal(false)}
//                     >
//                       ✕
//                     </button>

//                     <div className="otp-header">
//                       <div className="otp-header-content">

//                         <div className="otp-logo">
//                           <i className="bi bi-shield-check"></i>
//                         </div>
//                       </div>

//                       <svg
//                         className="otp-header-wave"
//                         viewBox="0 0 500 160"
//                         preserveAspectRatio="none"
//                       >
//                         <path
//                           d="M0,70 C80,140 180,20 280,70 C360,110
//                        430,60 500,90 L500,160 L0,160 Z"
//                           fill="#ffffff"
//                           opacity=".45"
//                         />

//                         <path
//                           d="M0,90
//                        C120,150
//                        250,30
//                        500,95
//                        L500,160
//                        L0,160
//                        Z"
//                           fill="#ffffff"
//                         />
//                       </svg>

//                     </div>

//                     <div className="otp-body">

//                       <h2>Verify OTP</h2>

//                       <p>
//                         Enter the OTP sent to
//                       </p>

//                       <h5>{googleEmail}</h5>
//                       <p className="otp-timer">
//                         OTP expires in{" "}
//                         <span>
//                           00:{timeLeft.toString().padStart(2, "0")}
//                         </span>
//                       </p>
//                       <input
//                         type="text"
//                         maxLength={6}
//                         value={otp}
//                         onChange={(e) => setOtp(e.target.value)}
//                         placeholder="Enter OTP"
//                       />

//                       <small>
//                         Didn't receive OTP?
//                         <span className="resend" onClick={handleResendOtp}>
//                           Resend OTP
//                         </span>
//                       </small>

//                     </div>

//                     <div className="otp-footer">

//                       <button
//                         className="cancel-btn"
//                         onClick={() => setShowOtpModal(false)}
//                       >
//                         Cancel
//                       </button>

//                       <button
//                         className={`verify-btn ${otpExpired ? "verify-btn-disabled" : ""}`}
//                         onClick={handleVerifyOtp}
//                         disabled={otpExpired}
//                       >
//                        Verify OTP
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// {/*              
//               <div className="form-group mb-4">
//                 <label className="form-label">Password</label>
//                 <div className="custom-input-group">
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     className="custom-input"
//                     placeholder="••••••••••••"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     required
//                   />
//                   <i
//                     className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"} password-toggle-icon`}
//                     onClick={() => setShowPassword(!showPassword)}
//                     style={{ cursor: "pointer" }}
//                   ></i>
//                 </div>
//               </div>

//               <button
//                 type="submit"
//                 className="btn-primary-custom-model w-100"
//                 disabled={isLoading} // Disable while loading
//                 style={{
//                   opacity: isLoading ? 0.7 : 1,
//                   cursor: isLoading ? "not-allowed" : "pointer",
//                 }}
//               >
//                 Log In
//               </button>
//             </div>
//           </div>
//         </div> */}
//         {/* );
// }; */}

//         export default Login;


// import React, { useState } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { loginUser } from "../redux/auth/authActions";
// import Loader from "../components/Loader"; // Import your reusable Loader
// import "../assets/css/setPassword.css"; // Import your CSS
// import { showApiErrorToast } from "../utils/toastErrorHandler";
// import { toast } from "react-toastify";

// const Login = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   // Form State
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);

//   // Loading State
//   const [isLoading, setIsLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true); // Start Loader

//     try {
//       // 1. Dispatch Login Action
//       const resultAction = await dispatch(
//         loginUser({
//           email: email,
//           password: password,
//         }),
//       );

//       // 2. Check if the action was fulfilled (Success)
//       if (loginUser.fulfilled.match(resultAction)) {
//         const responseData = resultAction.payload;

//         if (responseData.success) {
//           // --- SUCCESS ---
//           // Save token with key "token" to match App.js logic
//           localStorage.setItem("token", responseData.data.token);

//           // Optional: Save user details
//           localStorage.setItem("user", JSON.stringify(responseData.data));
//           localStorage.removeItem("dashboard_animation_played");
//           // Redirect to Dashboard & Reload to update App state
//           toast.success(responseData.message, {
//             autoClose: 3000, // 3000ms = 3 seconds
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           setIsLoading(false);
//           setTimeout(() => {
//             window.location.href = "/dashboard";
//           }, 1000);

//           // navigate("/dashboard");
//         } else {
//           // --- LOGIC FAILURE (e.g., Wrong Password) ---
//           showApiErrorToast(responseData.message);
//           setIsLoading(false); // Stop Loader
//         }
//       } else {
//         // --- NETWORK/API ERROR ---
//         const errorMessage =
//           resultAction.payload || "Login failed. Please try again.";

//         if (
//           errorMessage ==
//           "Failed to connect to 103.131.196.130:1433 - Could not connect (sequence)"
//         ) {
//           showApiErrorToast("Your database connection loss");
//         } else {
//           showApiErrorToast(errorMessage);
//         }
//         setIsLoading(false); // Stop Loader
//       }
//     } catch (error) {
//       showApiErrorToast(error.message);
//       setIsLoading(false); // Stop Loader
//     }
//   };

//   return (
//     <div className="password-page-wrapper">
//       {/* 1. Full Screen Loader Component */}
//       <Loader isLoading={isLoading} />

//       {/* 2. Purple Header Bar */}
//       <div className="purple-header-bar">
//         <h2 className="header-title">Welcome Back</h2>
//       </div>

//       {/* 3. Wave SVG */}
//       <div className="wave-container">
//         <svg
//           viewBox="0 0 1440 320"
//           xmlns="http://www.w3.org/2000/svg"
//           preserveAspectRatio="none"
//         >
//           <path
//             fill="#5b5fef"
//             fillOpacity="1"
//             d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,122.7C960,117,1056,171,1152,197.3C1248,224,1344,224,1392,224L1440,224L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
//           ></path>
//         </svg>
//       </div>

//       {/* 4. Login Form */}
//       <div className="white-content-area">
//         <div className="content-container">
//           <h3 className="fw-bold mb-3 text-center text-dark">Log In</h3>
//           <p className="text-muted text-center mb-4 small-text">
//             Please sign in to continue using our app
//           </p>

//           <form onSubmit={handleSubmit}>
//             {/* Email Field */}
//             <div className="form-group mb-3">
//               <label className="form-label">Email Address</label>
//               <div className="custom-input-group">
//                 <input
//                   type="email"
//                   className="custom-input"
//                   placeholder="name@example.com"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   required
//                 />
//                 <i
//                   className="bi bi-envelope password-toggle-icon"
//                   style={{ pointerEvents: "none" }}
//                 ></i>
//               </div>
//             </div>

//             {/* Password Field */}
//             <div className="form-group mb-4">
//               <label className="form-label">Password</label>
//               <div className="custom-input-group">
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   className="custom-input"
//                   placeholder="••••••••••••"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   required
//                 />
//                 <i
//                   className={bi ${showPassword ? "bi-eye-slash" : "bi-eye"} password-toggle-icon}
//                   onClick={() => setShowPassword(!showPassword)}
//                   style={{ cursor: "pointer" }}
//                 ></i>
//               </div>
//             </div>

//             {/* Submit Button */}
//             <button
//               type="submit"
//               className="btn-primary-custom-model w-100"
//               disabled={isLoading} // Disable while loading
//               style={{
//                 opacity: isLoading ? 0.7 : 1,
//                 cursor: isLoading ? "not-allowed" : "pointer",
//               }}
//             >
//               Log In
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;




// import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { loginUser } from "../redux/auth/authActions";
// import Loader from "../components/Loader"; // Import your reusable Loader
// import "../assets/css/login.css"; // Import your CSS
// import left from "../assets/images/left-background.png"
// import skyeye from "../assets/images/sky-rp-logo.png"
// import google from "../assets/images/google.png"
// import facebook from "../assets/images/facebook.png"
// import github from "../assets/images/github.png"
// import { showApiErrorToast } from "../utils/toastErrorHandler";
// import { toast } from "react-toastify";
// import { GoogleLogin } from "@react-oauth/google";
// import { googleLogin, verifyOtp, resendOtp } from "../redux/auth/authActions";

// const Login = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   // Form State
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [errors, setErrors] = useState({});

//   //OTP State

//   const [showOtpModal, setShowOtpModal] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [googleEmail, setGoogleEmail] = useState("");
//   const [timeLeft, setTimeLeft] = useState(60); // 60 seconds
//   const [otpExpired, setOtpExpired] = useState(false);
//   const [timerKey, setTimerKey] = useState(0);

//   // Loading State
//   const [isLoading, setIsLoading] = useState(false);

//   // Validation State
//   const validateForm = () => {
//     let newErrors = {};
//     const emailRegex = /^[a-z][a-z0-9._]*@(gmail|yahoo)\.(com)$/;
//     const passwordRegex = /^(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

//     if (!email.trim()) {
//       newErrors.email = "Email is required";
//     } else if (!emailRegex.test(email)) {
//       newErrors.email = "Enter a valid email address";
//     }
//     if (!password.trim()) {
//       newErrors.password = "Password is requied";
//     } else if (!passwordRegex.test(password)) {
//       newErrors.password = "Enter valid password Eg: abc@123"
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;
//     setIsLoading(true); // Start Loader

//     try {
//       // 1. Dispatch Login Action
//       const resultAction = await dispatch(
//         loginUser({
//           email,
//           password,
//         }),
//       );

//       // 2. Check if the action was fulfilled (Success)
//       if (loginUser.fulfilled.match(resultAction)) {
//         const responseData = resultAction.payload;

//         if (responseData.success) {
//           // --- SUCCESS ---
//           // Save token with key "token" to match App.js logic
//           localStorage.setItem("token", responseData.data.token);


//           // Optional: Save user details
//           localStorage.setItem("user", JSON.stringify(responseData.data));
//           localStorage.removeItem("dashboard_animation_played");
//           // Redirect to Dashboard & Reload to update App state
//           toast.success(responseData.message, {
//             autoClose: 3000, // 3000ms = 3 seconds
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           });
//           setIsLoading(false);
//           setTimeout(() => {
//             window.location.href = "/dashboard";
//           }, 1000);

//           // navigate("/dashboard");
//         } else {
//           // --- LOGIC FAILURE (e.g., Wrong Password) ---
//           showApiErrorToast(responseData.message);
//           setIsLoading(false); // Stop Loader
//         }
//       } else {
//         // --- NETWORK/API ERROR ---
//         const errorMessage =
//           resultAction.payload || "Login failed. Please try again.";
//         if (
//           errorMessage ==
//           "Failed to connect to 103.131.196.130:1433 - Could not connect (sequence)"
//         ) {
//           showApiErrorToast("Your database connection loss");
//         } else {
//           showApiErrorToast(errorMessage);
//         }
//         setIsLoading(false); // Stop Loader
//       }
//     } catch (error) {
//       showApiErrorToast(error.message);
//       setIsLoading(false); // Stop Loader
//     }
//   };


//   const handleGoogleSuccess = async (credentialResponse) => {
//     console.log("Google Response:", credentialResponse);
//     console.log("ID Token:", credentialResponse.credential);
//     setIsLoading(true);
//     try {
//       const idToken = credentialResponse.credential;
//       const result = await dispatch(
//         googleLogin(credentialResponse.credential)
//       );

//       if (googleLogin.fulfilled.match(result)) {
//         toast.success(result.payload.message);
//         localStorage.setItem(
//           "googleEmail",
//           result.payload.data.email
//         );
//         // navigate("/verify-otp");
//         setGoogleEmail(result.payload.data.email);
//         setShowOtpModal(true);
//         // toast.success("OTP sent to your email.");
//       }
//       else {
//         showApiErrorToast(result.payload || "Google Login Failed");
//       }
//     } catch (err) {
//       showApiErrorToast(err.message);
//     }
//     setIsLoading(false);
//   };
//   const handleGoogleError = () => {
//     showApiErrorToast("Google Login Failed");
//   };
//   const handleVerifyOtp = async () => {

//     const result = await dispatch(
//       verifyOtp({
//         email: googleEmail,
//         otp
//       })
//     );
//     if (verifyOtp.fulfilled.match(result)) {
//       localStorage.setItem(
//         "token",
//         result.payload.data.token
//       );
//       localStorage.setItem(
//         "user",
//         JSON.stringify(result.payload.data)
//       );
//       toast.success("OTP Verified");
//       setShowOtpModal(false);
//       window.location.href = "/dashboard";
//     }
//     else {
//       toast.error(result.payload?.message || "Invalid OTP");
//     }
//   };
//   const handleResendOtp = async () => {
//     const result = await dispatch(
//       resendOtp(googleEmail)
//     );
//     if (resendOtp.fulfilled.match(result)) {
//       toast.success(result.payload.message);
//       setOtp("");
//     setOtpExpired(false);
//     // Restart timer
//     setTimerKey(prev => prev + 1);
//     } else {
//       toast.error(result.payload);
//     }
//   };
//   useEffect(() => {
//     if (!showOtpModal) return;
//     setOtpExpired(false);
//     setTimeLeft(60);
//     const timer = setInterval(() => {
//       setTimeLeft((prev) => {
//         if (prev <= 1) {
//           clearInterval(timer);
//           setOtpExpired(true);
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);
//     return () => clearInterval(timer);
//   }, [showOtpModal, timerKey]);
//   return (
//     <div className="login-page">
//       {/* 1. Full Screen Loader Component */}
//       <Loader isLoading={isLoading} />

//       {/* 2. Login Card */}
//       <div className="login-card">

//         {/* 3. Left cointainer*/}
//         <div className="login-left"
//           style={{
//             backgroundImage: `url(${left})`,
//           }}>
//           <div className="login-overlay">
//             <div className="login-left-content">
//               <h2>Work Smarter. <br />Track Better.</h2>
//               <p>Experience a faster, smarter way to manage attendance
//                 with real-time monitoring and effortless workforce visibility.
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Right Cointainer */}

//         <div className="login-right-content">
//           {/* <div className="login-logo-area">
//             <img src={skyeye} alt="SkyEye" className="login-company-logo" />
//             <span>SkyEye</span>
//           </div> */}
//           <h1>Welcome Back</h1>
//           <form onSubmit={handleSubmit}>
//             <div className="login-form-group">
//               <label>Email Address <span>*</span></label>
//               <div className="login-input-box">
//                 <i className="bi bi-envelope"></i>
//                 <input type="email"
//                   placeholder="Enter your email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)} />
//               </div>
//               {errors.email && (
//                 <small className="login-error-text"> {errors.email} </small>
//               )}
//             </div>
//             <div className="login-form-group">
//               <div className="login-password-label">
//                 <label>Password <span>*</span></label>
//                 <a href="/">Forgot Password?</a>
//               </div>
//               <div className="login-input-box">
//                 <i className="bi bi-lock"></i>
//                 <input type={showPassword ? "text" : "password"}
//                   placeholder="Enter password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)} />
//                 <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"} eye`}
//                   onClick={() => setShowPassword(!showPassword)}></i>
//               </div>
//               {errors.password && (
//                 <small className="login-error-text"> {errors.password} </small>
//               )}
//             </div>

//             {/* Button */}
//             <button type="submit" className="login-btn" disabled={isLoading}>
//               {isLoading ? "Loging In..." : "Log In"}
//             </button>
//             <div className="social-login">
//               <p>Or continue with</p>
//               <div className="login-social-icons">
//                 {/* <button type="button">
//                   <img src={google} alt="Google" />
//                 </button> */}
//                 <GoogleLogin
//                   onSuccess={handleGoogleSuccess}
//                   onError={handleGoogleError}
//                   useOneTap={false}
//                   className="google-icon"
//                 />
//                 {/* <button type="button">
//                   <img src={facebook} alt="Facebook" />
//                 </button>
//                 <button type="button">
//                   <img src={github} alt="Github" />
//                 </button> */}
//               </div>
//             </div>
//           </form>
//           {showOtpModal && (
//             <div className="otp-overlay">
//               <div className="otp-modal">

//                 <button
//                   className="otp-close"
//                   onClick={() => setShowOtpModal(false)}
//                 >
//                   ✕
//                 </button>

//                 <div className="otp-header">

//                   <div className="otp-header-content">

//                     <div className="otp-logo">
//                       <i className="bi bi-shield-check"></i>
//                     </div>
//                   </div>

//                   <svg
//                     className="otp-header-wave"
//                     viewBox="0 0 500 160"
//                     preserveAspectRatio="none"
//                   >
//                     <path
//                       d="M0,70 C80,140 180,20 280,70 C360,110
//                       430,60 500,90 L500,160 L0,160 Z"
//                       fill="#ffffff"
//                       opacity=".45"
//                     />

//                     <path
//                       d="M0,90
//                       C120,150
//                       250,30
//                       500,95
//                       L500,160
//                       L0,160
//                       Z"
//                       fill="#ffffff"
//                     />
//                   </svg>

//                 </div>

//                 <div className="otp-body">

//                   <h2>Verify OTP</h2>

//                   <p>
//                     Enter the OTP sent to
//                   </p>

//                   <h5>{googleEmail}</h5>
//                   <p className="otp-timer">
//                     OTP expires in{" "}
//                     <span>
//                       00:{timeLeft.toString().padStart(2, "0")}
//                     </span>
//                   </p>
//                   <input
//                     type="text"
//                     maxLength={6}
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value)}
//                     placeholder="Enter OTP"
//                   />

//                   <small>
//                     Didn't receive OTP?
//                     <span className="resend" onClick={handleResendOtp}>
//                       Resend OTP
//                     </span>
//                   </small>

//                 </div>

//                 <div className="otp-footer">

//                   <button
//                     className="cancel-btn"
//                     onClick={() => setShowOtpModal(false)}
//                   >
//                     Cancel
//                   </button>

//                   <button
//                     className={`verify-btn ${otpExpired ? "verify-btn-disabled" : ""}`}
//                     onClick={handleVerifyOtp}
//                     disabled={otpExpired}
//                   >
//                     Verify OTP
//                   </button>

//                 </div>

//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React from "react";
import { useState, useEffect } from "react";
import "../assets/css/login.css";
import google from "../assets/images/google.png"
import avatar from "../assets/images/ava.png";
import team from "../assets/images/team1.png";
// import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../redux/auth/authActions";
import Loader from "../components/Loader"; // Import your reusable Loader
import "../assets/css/setPassword.css"; // Import your CSS
import { showApiErrorToast } from "../utils/toastErrorHandler";
import { toast } from "react-toastify";
import { GoogleLogin } from "@react-oauth/google";
import { googleLogin, verifyOtp, resendOtp } from "../redux/auth/authActions";
// import google from "../assets/images/google.png"

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const [showForm, setShowForm] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [googleEmail, setGoogleEmail] = useState("");
  const [timeLeft, setTimeLeft] = useState(60);
  const [otpExpired, setOtpExpired] = useState(false);
  const [timerKey, setTimerKey] = useState(0);

  const validateForm = () => {
    let newErrors = {};

    const emailRegex = /^[a-z][a-z0-9._]*@(gmail|yahoo|company|outlook)\.(com)$/;
    // const passwordRegex =
    //   /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9\s]).{4,}$/;

    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Enter a valid email address";
    }

    // if (!password.trim()) {
    //   newErrors.password = "Password is required";
    // } else if (!passwordRegex.test(password)) {
    //   newErrors.password =
    //     "Use uppercase, lowercase, number & special character.";
    // }
    // setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowForm(true);
  //   }, 1400); // Avatar reaches ~75%

  //   return () => clearTimeout(timer);
  // }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true); // Start Loader

    try {
      // 1. Dispatch Login Action
      const resultAction = await dispatch(
        loginUser({
          email,
          password,
        }),
      );

      // 2. Check if the action was fulfilled (Success)
      if (loginUser.fulfilled.match(resultAction)) {
        const responseData = resultAction.payload;

        if (responseData.success) {
          // --- SUCCESS ---
          // Save token with key "token" to match App.js logic
          localStorage.setItem("token", responseData.data.token);


          // Optional: Save user details
          localStorage.setItem("user", JSON.stringify(responseData.data));
          localStorage.removeItem("dashboard_animation_played");

          /* Signing in clocks you in. Say so rather than leaving it to be
             noticed: the header button will already read "Clock Out", and a
             button in the state you did not put it in reads as a bug.
             `applied` is false on a second login the same day, when there was
             nothing left to record. */
          const autoPunch = responseData.data?.autoPunch;

          // Redirect to Dashboard & Reload to update App state
          toast.success(
            autoPunch?.applied
              ? `${responseData.message} — you have been clocked in.`
              : responseData.message,
            {
              autoClose: 3000, // 3000ms = 3 seconds
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            },
          );
          // setIsLoading(false);
          localStorage.setItem("dashboard_loading", "true");
          console.log("Navigating...");

          setTimeout(() => {
            window.location.href = "/dashboard";
          }, 1000);
          // navigate("/dashboard", {replace: true});
        } else {
          // --- LOGIC FAILURE (e.g., Wrong Password) ---
          showApiErrorToast(responseData.message);
          setIsLoading(false); // Stop Loader
        }
      } else {
        // --- NETWORK/API ERROR ---
        const errorMessage =
          resultAction.payload || "Login failed. Please try again.";
        if (
          errorMessage ==
          "Failed to connect to 103.131.196.130:1433 - Could not connect (sequence)"
        ) {
          showApiErrorToast("Your database connection loss");
        } else {
          showApiErrorToast(errorMessage);
        }
        setIsLoading(false); // Stop Loader
      }
    } catch (error) {
      showApiErrorToast(error.message);
      setIsLoading(false); // Stop Loader
    }
  };


  const handleGoogleSuccess = async (credentialResponse) => {
    console.log("Google Response:", credentialResponse);
    console.log("ID Token:", credentialResponse.credential);
    setIsLoading(true);
    try {
      const idToken = credentialResponse.credential;
      const result = await dispatch(
        googleLogin(credentialResponse.credential)
      );

      if (googleLogin.fulfilled.match(result)) {
        toast.success(result.payload.message);
        localStorage.setItem(
          "googleEmail",
          result.payload.data.email
        );
        // navigate("/verify-otp");
        setGoogleEmail(result.payload.data.email);
        setShowOtpModal(true);
        // toast.success("OTP sent to your email.");
      }
      else {
        showApiErrorToast(result.payload || "Google Login Failed");
      }
    } catch (err) {
      showApiErrorToast(err.message);
    }
    setIsLoading(false);
  };
  const handleGoogleError = () => {
    showApiErrorToast("Google Login Failed");
  };
  const handleVerifyOtp = async () => {

    const result = await dispatch(
      verifyOtp({
        email: googleEmail,
        otp
      })
    );
    if (verifyOtp.fulfilled.match(result)) {
      localStorage.setItem(
        "token",
        result.payload.data.token
      );
      localStorage.setItem(
        "user",
        JSON.stringify(result.payload.data)
      );
      toast.success("OTP Verified");
      setShowOtpModal(false);
      window.location.href = "/dashboard";
    }
    else {
      toast.error(result.payload?.message || "Invalid OTP");
    }
  };
  const handleResendOtp = async () => {
    const result = await dispatch(
      resendOtp(googleEmail)
    );
    if (resendOtp.fulfilled.match(result)) {
      toast.success(result.payload.message);
      setOtp("");
      setOtpExpired(false);
      // Restart timer
      setTimerKey(prev => prev + 1);
    } else {
      toast.error(result.payload);
    }
  };
  useEffect(() => {
    if (!showOtpModal) return;
    setOtpExpired(false);
    setTimeLeft(60);
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setOtpExpired(true);
          return 0;
        }
        return prev - 1;
      });
    }, 5000);
    return () => clearInterval(timer);
  }, [showOtpModal, timerKey]);
  return (
    <div className="login-page">
      {/* <Loader isLoading={isLoading} /> */}
      <div className="container-fluid h-100">
        <div className="row h-100">
          <div className="col-lg-6 left-panel">
            <div className="content">
              <h1>
                Welcome to
                <br />
                <span>SkyEye</span>
              </h1>
              <div className="line"></div>
              <p>
                Skyeye is a smart platform that helps
                teams collaborate, manage projects,
                monitor tasks and achieve business
                goals efficiently.
              </p>
            </div>
            <svg
              className="wave"
              viewBox="0 0 500 900"
              preserveAspectRatio="none"
            >
              <path
                d="
                M500 0

                C350 140
                600 240
                430 420

                C250 600
                620 720
                430 900

                L500 900
                Z
                "
              />
            </svg>
            <img
              src={team}
              className="team-image"
              alt=""
            />
          </div>

          <div className="col-lg-6 right-panel">
            <div className="login-wrapper">

              {/* <motion.div
                className="avatar"
                // initial={{
                //   y: 1500,
                //   opacity: 0
                // }}
                // animate={{
                //   y: 0,
                //   opacity: 1
                // }}
                // transition={{
                //   // type: "spring",
                //   duration: 1,
                //   ease: "easeOut"
                //   // stiffness: 90,
                //   // damping: 12,
                // }}
                initial={{
                  x: -250,
                  opacity: 0
                }}
                animate={{
                  x: 0,
                  opacity: 1
                }}
                transition={{
                  duration: 0.8,
                  ease: "easeOut"
                  
                }}
                 onAnimationComplete={() => setShowForm(true)}
              >
                <img src={avatar} alt="" />
              </motion.div> */}

              <div className="avatar">
                <img src={avatar} alt="" />
              </div>

              {/* <motion.div
                className="login-card"
                // initial={{
                //   opacity: 0,
                //   scale: 0.8,
                //   y: 40,
                // }}
                // animate={
                //   showForm
                //     ? {
                //       opacity: 1,
                //       scale: 1,
                //       y: 0,
                //     }
                //     : {
                //       opacity: 0,
                //       scale: 0.8,
                //       y: 40,
                //     }
                // }

                // transition={{
                //   // type: "spring",
                //   duration: 0.4,
                //   ease: "easeOut",
                //   // stiffness: 10,
                //   // damping: 12,
                // }}
                initial={{
                  x: 250,
                  opacity: 0
                }}
                animate={{
                  x: 0,
                  opacity: 1
                }}
                transition={{
                  duration: 0.8,
                  ease: "easeOut"

                }}
                onAnimationComplete={() => setShowForm(true)}
              > */}
              <div className="login-card">
                <form onSubmit={handleSubmit} className="login-form">
                  <h2>Login</h2>
                  <p>
                    Welcome Back! Please login
                    to continue.
                  </p>
                  <div className="mb-3">
                    <label>Email <span>*</span></label>
                    <input
                      className="form-control"
                      type="email"
                      placeholder="Enter email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {
                      errors.email &&
                      (
                        <small className="login-error-text">
                          {errors.email}
                        </small>
                      )
                    }
                  </div>
                  <div className="password mb-3">
                    <label>Password <span>*</span></label>
                    <div className="password-box">
                      <input
                        className="form-control"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <i
                        className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"} eye`}
                        onClick={() => setShowPassword(!showPassword)}
                      ></i>
                    </div>
                    {/* {
                      errors.password &&
                      (
                        <small className="login-error-text">
                          {errors.password}
                        </small>
                      )
                    } */}

                  </div>
                  {/* <div className="forgot-password">
                    <a href="/">Forgot Password?</a>
                  </div> */}
                  <button
                    type="submit"
                    className="btn login-btn mt-4"
                    disabled={isLoading}
                  >

                    {
                      isLoading
                        ?
                        "Logging In..."
                        :
                        "Login"
                    }

                  </button>
                  <div className="social-login">
                    <p>Or continue with</p>
                    <div className="login-social-icons">

                      <GoogleLogin
                        onSuccess={handleGoogleSuccess}
                        onError={handleGoogleError}
                        useOneTap={false}
                        className="google-icon" />

                    </div>
                  </div>
                </form>
              </div>
              {/* </motion.div> */}
            </div>
          </div>
          {showOtpModal && (
            <div className="otp-overlay">
              <div className="otp-modal">

                <button
                  className="otp-close"
                  onClick={() => setShowOtpModal(false)}
                >
                  ✕
                </button>

                <div className="otp-header">
                  <div className="otp-header-content">

                    <div className="otp-logo">
                      <i className="bi bi-shield-check"></i>
                    </div>
                  </div>

                  <svg
                    className="otp-header-wave"
                    viewBox="0 0 500 160"
                    preserveAspectRatio="none"
                  >
                    <path
                      d="M0,70 C80,140 180,20 280,70 C360,110
                       430,60 500,90 L500,160 L0,160 Z"
                      fill="#ffffff"
                      opacity=".45"
                    />

                    <path
                      d="M0,90
                       C120,150
                       250,30
                       500,95
                       L500,160
                       L0,160
                       Z"
                      fill="#ffffff"
                    />
                  </svg>

                </div>

                <div className="otp-body">

                  <h2>Verify OTP</h2>

                  <p>
                    Enter the OTP sent to
                  </p>

                  <h5>{googleEmail}</h5>
                  <p className="otp-timer">
                    OTP expires in{" "}
                    <span>
                      00:{timeLeft.toString().padStart(2, "0")}
                    </span>
                  </p>
                  <input
                    type="text"
                    maxLength={6}
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    placeholder="Enter OTP"
                  />

                  <small>
                    Didn't receive OTP?
                    <span className="resend" onClick={handleResendOtp}>
                      Resend OTP
                    </span>
                  </small>

                </div>

                <div className="otp-footer">

                  <button
                    className="cancel-btn"
                    onClick={() => setShowOtpModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className={`verify-btn ${otpExpired ? "verify-btn-disabled" : ""}`}
                    onClick={handleVerifyOtp}
                    disabled={otpExpired}
                  >
                    Verify OTP
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;